<template>
    <div class="w-full h-full">
        <form @submit.prevent="editTransaction" class="w-full h-full p-1 flex flex-col justify-between pb-10" action="">
            <div class="flex flex-col">
                <div class="grid grid-cols-2 gap-2 mb-4">
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Transaction Date*</label>
                        <input type="date" required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="transactionData.transaction_date">
                    </div>
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Target Company</label>
                        <select class="p-1 border mt-1 border-gray-400 rounded-md" v-model="transactionData.target_company_id">
                            <option v-for="company in companies" :key="company.id" :value="company.id">{{ company.company_name }}</option>
                        </select>
                    </div>
                    <div class="flex flex-col">
                        <label class="tracking-widest text-gray-500" for="">Tombstone Link</label>
                        <input type="url" class="p-1 border mt-1 border-gray-400 rounded-md" v-model="transactionData.google_drive_tombstone_link">
                    </div>
                </div>
                <div class="w-full flex flex-col">
                    <div class="w-full border-b mb-2">
                        Contingency Payments
                    </div>
                    <div class="grid grid-cols-2 gap-2">
                        <div v-for="(payment, idx) in contingencyPayments" :key="payment.id" class="border shadow-md p-2 flex flex-col">
                            <div class="w-full flex justify-end">
                                <div>
                                    <base-button-negative @click.prevent="removePayment(idx)">
                                        -
                                    </base-button-negative>
                                </div>
                            </div>
                            <div class="flex flex-col h-full justify-between">
                                <div class="flex flex-col mb-1">
                                    <label class="tracking-widest text-gray-500" for="">Payment Date*</label>
                                    <input type="date" required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="payment.payment_date">
                                </div>
                                <div class="flex flex-col mb-1">
                                    <label class="tracking-widest text-gray-500" for="">Status*</label>
                                    <select required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="payment.status">
                                        <option value="pending">Pending</option>
                                        <option value="paid">Paid</option>
                                        <option value="lost">Lost</option>
                                    </select>
                                </div>
                                <div class="flex flex-col">
                                    <label class="tracking-widest text-gray-500" for="">Payment Description*</label>
                                    <textarea  required class="p-1 border mt-1 border-gray-400 rounded-md" v-model="payment.contingency_description"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <base-button @click.prevent="addContingencyPayment">Add Contingency Payment</base-button>
                    </div>
                </div>
            </div>
            <div class="flex w-full justify-center space-x-2">
                <base-button-affirmative>Save</base-button-affirmative>
                <base-button-negative @click.prevent="close">Cancel</base-button-negative>
            </div>
        </form>
    </div>
</template>

<script setup>
import { defineEmits, reactive, ref, defineProps } from 'vue';

const emit = defineEmits(['edit-transaction', 'close'])
const props = defineProps(['client', 'companies', 'transaction'])

const transactionData = reactive({
    id: props.transaction.id,
    transaction_date: props.transaction.transaction_date,
    target_company_id: props.transaction.target_company_id,
    google_drive_tombstone_link: props.transaction.google_drive_tombstone_link
})

function close(){
    emit('close')
}

function editTransaction(){
    const data = {
        transaction_data: transactionData,
        contingency_payment_data: contingencyPayments.value
    }
    emit('edit-transaction', data)
}

const contingencyPayments = ref(props.transaction.contingency_payments)

function removePayment(idx) {
    contingencyPayments.value.splice(idx, 1)
}

function addContingencyPayment(){
    contingencyPayments.value.push({
        id: Math.random(),
        contingency_description: null,
        payment_date: null,
        status: 'pending'
    })
}

</script>
